// The filter vocabulary of `/teams`, named once so the type derives from the values.

import type { AgeGroup, TeamRead } from '@volee/api-client'

export const TEAM_GENDERS = ['male', 'female', 'open'] as const

export type TeamGenderFilter = (typeof TEAM_GENDERS)[number]

/** The genders actually fielded, in the filter's order: the filter shows only with two or more. */
export function gendersOf(teams: readonly TeamRead[]): readonly TeamGenderFilter[] {
  return TEAM_GENDERS.filter((gender) => teams.some((team) => team.gender === gender))
}

/** The categories actually fielded, for the second filter row. */
export function ageGroupsOf(teams: readonly TeamRead[]): readonly AgeGroup[] {
  return [...new Set(teams.map((team) => team.age_group))]
}
